import apiHandler from "../core/apiHandler";

const creditNoteBalanceApi = apiHandler('credit-notes/balances');
export default creditNoteBalanceApi;
